import React, {useState, useContext} from 'react'
import {Button, Spinner, Row, Col, Alert} from 'react-bootstrap'
import DataGrid from 'react-data-grid'

import StoryContext from '../store/context'
import {URL_API} from '../store/globals'

const Admin = () => {
  const store = useContext(StoryContext)
  const [loading, setLoad] = useState(false)
  const [curentClient, setCurentClient] = useState(null)
  const [alert1c, setAlert1c] = useState({type: null, message: ''})

  const change1c = async () => {
    try {
      setLoad(true)
      const response = await fetch(`${URL_API}/api/change1c`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const json = await response.json()
      setLoad(false)
      setAlert1c({type: null, message: ''})
    } catch (e) {
      setLoad(false)
      setAlert1c({type: 'danger', message: 'Ошибка обмена'})
    }
  }

  const columnsClient = [
    {name: 'Код', key: 'code'},
    {name: 'Найменування', key: 'name'},
  ]

  const TextEditor = ({row, column}) => {
    return (
      <input
        className="textEditor"
        defaultValue={row[column.key]}
        onChange={event => row.set({...row, [column.key]: event.target.value})}
        onBlur={() => {
          row.setFetch()
        }}
        autoFocus
      />
    )
  }

  const columnsEmployee = [
    {name: 'Код', key: 'code'},
    {name: 'Найменування', key: 'name'},
    {name: 'Категорія', key: 'category'},
    {name: 'Логін', key: 'login', editor: TextEditor},
    {name: 'Пароль', key: 'password', editor: TextEditor},
  ]

  const columnsProduct = [
    {name: 'Код', key: 'code'},
    {name: 'Найменування', key: 'name'},
  ]

  const columnsOutlet = [
    {name: 'Код', key: 'code'},
    {name: 'Найменування', key: 'name'},
    {
      name: 'Мерч',
      key: 'merchandiser',
      formatter({row}) {
        return <>{row.merchandiser ? row.merchandiser.name : ''}</>
      },
    },
  ]

  const sorted = (A, B) => (A.name < B.name ? -1 : 1)

  return (
    <Col>
      <Alert show={!!alert1c.type} variant={alert1c.type}>
        {alert1c.message}
      </Alert>
      <Row style={{marginBottom: 5}}>
        <Button onClick={change1c} style={{width: 150, marginLeft: 10}}>
          Обмін з 1С
          {loading && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </Button>
      </Row>
      <Row>
        <Col>
          <DataGrid
            columns={columnsClient}
            rows={store.clients.slice().sort(sorted)}
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
            onRowClick={item => setCurentClient(item.uuid)}
          />
          <DataGrid
            style={{marginTop: 10}}
            columns={columnsProduct}
            rows={store.products.slice().sort(sorted)}
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
          />
        </Col>
        <Col>
          <DataGrid
            columns={columnsOutlet}
            rows={store.outlets
              .filter(
                item => !!curentClient && curentClient === item.client.uuid,
              )
              .sort(sorted)}
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
          />
          <DataGrid
            style={{marginTop: 10}}
            columns={columnsEmployee}
            rows={store.employees.slice().sort(sorted)}
            defaultColumnOptions={{
              sortable: true,
              resizable: true,
            }}
          />
        </Col>
      </Row>
    </Col>
  )
}

export default Admin
